export enum GoalImpactLevel {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}
